import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import { Router } from "./router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./locales/i18n";
import "./utils/initMoment";
import { ToastContainer } from "react-toastify";
import { CookiesProvider } from "react-cookie";
import { store } from "./utils/store";
import { Provider } from "jotai";

if (process.env.REACT_APP_LOGGING !== "true") {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastContainer
        position={"bottom-right"}
        autoClose={2000}
        theme={"colored"}
        draggable={true}
        pauseOnFocusLoss={false}
        pauseOnHover={false}
      />
      <Provider store={store}>
        <CookiesProvider>
          <RouterProvider router={Router} />
        </CookiesProvider>
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
